import { render } from "./ComponentUploadHtml.vue?vue&type=template&id=055e0dfb&scoped=true"
import script from "./ComponentUploadHtml.vue?vue&type=script&lang=js"
export * from "./ComponentUploadHtml.vue?vue&type=script&lang=js"

import "./ComponentUploadHtml.vue?vue&type=style&index=0&id=055e0dfb&scoped=true&lang=css"

import exportComponent from "/app/app-cliente/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-055e0dfb"]])

export default __exports__